import { get, post, put } from ".";

export const postUserSignin = (data) => {
  return post(`/api/user/signIn`, false, data);
};
export const postUserSignUp = (data) => {
  return post(`/api/user/checkSignUpFormStep1`, false, data);
};
export const postUserSignUpFinal = (data) => {
  return post(`/api/user/signUp`, false, data);
};
export const postUserCheckCodeForget = (data) => {
  return post(`/api/user/checkForgetPassCode`, false, data);
};
export const postUserCheckCode = (data) => {
  return post(`/api/user/checkCode`, false, data);
};
export const postUserSigninForm2 = (data) => {
  return post(`/api/user/checkSignUpFormStep2`, false, data);
};
export const getMyInformation = () => {
  return get(`/api/user/myInfo`, true);
};

///FORGET PASSWORD

export const postForgetPassword = (data) => {
  return post(`/api/user/forgetPassword`, false, data);
};
export const postResetPassword = (data) => {
  return post(`/api/user/resetPassword`, false, data);
};

/// SIGNIN GROUP

export const postGroupSignUp = (data) => {
  return post(`/api/user/groupSignUp`, false, data);
};

export const putGroupSignUp2 = (data) => {
  return put(`/api/user/signUpStep2ForGroups`, true, data);
};
export const putGroupSignUp3 = (data) => {
  return put(`/api/user/signUpStep3ForGroups`, true, data);
};
export const putGroupSignUp4 = (data) => {
  return put(`/api/user/signUpStep4ForGroups`, true, data);
};
export const putSetImageGroup = (data) => {
  return put(`/api/user/setPic`, true, data);
};
